import { FC } from 'react';
import { createPortal } from 'react-dom';
import { Props } from './types';

const Portal: FC<Props> = ({ children }) =>
  createPortal(children, document.getElementById('root')!);

export default Portal;
